// eslint-disable-next-line filenames/no-index
export { config } from './config.js'
export { run } from './run/main.js'
